export var API_PATH;
(function (API_PATH) {
    API_PATH["QUERY_INTENTION"] = "/api/altas/marketing/query/userTag";
    API_PATH["QUERY_USER_PERSONA"] = "/api/altas/marketing/query/userPersona";
})(API_PATH || (API_PATH = {}));
export var ScoreType;
(function (ScoreType) {
    ScoreType["HotelScore"] = "1";
    ScoreType["TicketScore"] = "2";
    ScoreType["VacationScore"] = "3";
    ScoreType["TrafficScore"] = "4";
})(ScoreType || (ScoreType = {}));
export var TravelServiceType;
(function (TravelServiceType) {
    TravelServiceType["Hotel"] = "1";
    // 酒店
    TravelServiceType["Flight"] = "2";
    // 机票
    TravelServiceType["Train"] = "3";
    // 火车票
    TravelServiceType["Ticket"] = "5";
    // 门票
    TravelServiceType["Vacation"] = "6"; // 度假
})(TravelServiceType || (TravelServiceType = {}));
/**
 * 路由场景
 * - PersonaCrowd：人群场景，调权顺序为：人群定向 > 业务意向 > 运营默认
 * - BizDispatch：业务分发场景，调权顺序为：业务意向 > 人群定向 > 运营默认
 */
export var RouterScene;
(function (RouterScene) {
    RouterScene["PersonaCrowd"] = "personaCrowd";
    RouterScene["BizDispatch"] = "bizDispatch";
})(RouterScene || (RouterScene = {}));
